import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeader from "../SectionHeader";
import Reveal from "../Reveal";
import VideoFrame from "../VideoFrame";
import { useVideos } from "../../data/site";

export const FeaturedWork = () => {
  const videos = useVideos();
  const featured = videos
    .filter((v) => v.featured)
    .sort((a, b) => (a.homeOrder || 0) - (b.homeOrder || 0));

  return (
    <section id="work" data-testid="work-section" className="bg-[#111] section-pad scroll-mt-16">
      <div className="container-x">
        <SectionHeader
          eyebrow="The work"
          eyebrowTestId="work-eyebrow"
          title="Some of our work."
          support="Every one of these is client work. None of it is a template."
        />

        <div className="home-grid grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="featured-grid">
          {featured.map((v, i) => (
            <Reveal key={v.id} delay={(i % 4) * 0.07} className={v.aspect === "9:16" ? "row-span-2" : "col-span-2"}>
              <VideoFrame video={v} className="w-full h-full !row-span-1 !col-span-1" />
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 md:mt-20 text-center">
          <p className="font-heading text-xl md:text-2xl font-bold text-white/80">
            A small sample. <span className="text-white/40">10,000 videos over five years.</span>
          </p>
          <Link to="/work" data-testid="view-collection-btn" className="btn-secondary mt-7">
            View full collection <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default FeaturedWork;
